import http from './http';
import type {
  Job,
  CreateJobPosting,
  JobApplication,
  ApplyJobRequest,
  JobFilter,
  PaginatedResponse,
  JobListResponse,
} from '@/types';

interface ApiResponse<T> {
  data: T;
}

export const jobApi = {
  getGuestList: (params: JobFilter) => http.get<JobListResponse>('/guest-job-postings', { params }).then((r) => r.data),

  getList: (params: JobFilter) => http.get<JobListResponse>('/job-postings', { params }).then((r) => r.data),

  getById: (id: string) => http.get<ApiResponse<Job>>(`/job-postings/${id}`).then((r) => r.data.data),

  getMine: () => http.get<JobListResponse>('/job-postings').then((r) => r.data),

  createJobPosting: (body: CreateJobPosting) => http.post<Job>('/job-postings', body).then((r) => r.data),

  updateJobPosting: (id: string, body: Partial<CreateJobPosting>) => http.patch<Job>(`/job-postings/${id}`, body).then((r) => r.data),

  patchJobPosting: (id: string, body: Partial<Job>) => http.patch<Job>(`/job-postings/${id}`, body).then((r) => r.data),

  deleteJobPosting: (id: string) => http.delete(`/job-postings/${id}`).then((r) => r.data),

  // Applications
  getApplications: (id: string) => http.get<JobApplication[]>(`/jobs/${id}/applications`).then((r) => r.data),

  apply: (id: string, body: ApplyJobRequest) =>
    http.post<JobApplication>(`/jobs/${id}/apply`, body).then((r) => r.data),

  getMyApplications: () => http.get<JobApplication[]>('/jobs/applications/mine').then((r) => r.data),

  updateApplicationStatus: (jobId: string, appId: string, status: string) =>
    http.patch(`/jobs/${jobId}/applications/${appId}`, { status }).then((r) => r.data),

  getCategories: () => http.get<ApiResponse<any[]>>('/jobs/categories').then((r) => r.data.data),
};
